import { HADITH_OF_THE_DAY_DATA, HADITH_OF_THE_MONTH_DATA, HADITH_SEARCH_DATA } from '../action/Hadith';

const initialState = {
  hadithSearchData: false,
  hadithOfTheDayData: false,
  hadithOfTheMonthData: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case HADITH_SEARCH_DATA:
      return {
        ...state,
        hadithSearchData: action.payload.data,
        totalDocuments: action.payload.totalDocuments,
      };
    case HADITH_OF_THE_DAY_DATA:
      return {
        ...state,
        hadithOfTheDayData: action.payload,
      };
    case HADITH_OF_THE_MONTH_DATA:
      return {
        ...state,
        hadithOfTheMonthData: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
